import { toast } from "@/components/common/Toast";
import { missionQueryKeys } from "@/constants/queryKeys/missionQueryKeys";
import { ROUTES } from "@/constants/routes";
import { useWlPath } from "@/hooks/common/useWlPath";
import { useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import { useStartSurveyResponse } from ".";

export function useCreateMissionResponse({ missionId }: { missionId: string }) {
  const queryClient = useQueryClient();
  const router = useRouter();
  const { toWlPath } = useWlPath();

  const startResponse = useStartSurveyResponse({
    onSuccess: async () => {
      await queryClient.refetchQueries({
        queryKey: missionQueryKeys.missionResponseForMission(missionId),
      });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.mission(missionId) });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.userAnswerStatus(missionId) });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.missionParticipant(missionId) });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.missionPassword(missionId) });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.all() });
      queryClient.invalidateQueries({ queryKey: missionQueryKeys.userMissions() });
    },
    onError: (error: Error) => {
      toast.warning(error.message || "컨텐츠 시작에 실패했어요. 다시 시도해주세요", {
        id: "init-error",
      });
      router.push(toWlPath(ROUTES.MISSION(missionId)));
    },
  });

  return {
    startResponse,
  };
}
